import React from "react";
import {
  Paper,
  Box,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import { Search, FilterList, Print } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface OrderFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  filterStatus: string;
  onStatusChange: (value: string) => void;
}

const OrderFilters: React.FC<OrderFiltersProps> = ({
  searchQuery,
  onSearchChange,
  filterStatus,
  onStatusChange,
}) => {
  const { t } = useTranslation();

  return (
    <Paper
      sx={{
        p: 3,
        mb: 3,
        bgcolor: "background.paper",
        borderRadius: "8px",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        <TextField
          placeholder={t('admin.searchOrders')}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          sx={{
            flex: { xs: "none", sm: 1 },
            minWidth: { xs: "100%", sm: 300 },
          }}
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: "text.secondary" }} />
              </InputAdornment>
            ),
          }}
        />
        <FormControl sx={{ minWidth: { xs: "100%", sm: 200 } }} size="small">
          <InputLabel>{t('common.status')}</InputLabel>
          <Select
            value={filterStatus}
            label={t('common.status')}
            onChange={(e) => onStatusChange(e.target.value as string)}
            startAdornment={
              <FilterList sx={{ mr: 1, color: "text.secondary" }} />
            }
          >
            <MenuItem value="">{t('admin.allOrders')}</MenuItem>
            <MenuItem value="pending">{t('warranty.pending')}</MenuItem>
            <MenuItem value="confirmed">{t('orders.confirmed')}</MenuItem>
            <MenuItem value="shipped">{t('orders.shipped')}</MenuItem>
            <MenuItem value="delivered">{t('orders.delivered')}</MenuItem>
            <MenuItem value="cancelled">{t('orders.cancelled')}</MenuItem>
          </Select>
        </FormControl>
        <Button
          variant="outlined"
          startIcon={<Print />}
          size="small"
          sx={{
            minWidth: { xs: "100%", sm: "auto" },
            borderColor: "rgba(0,212,255,0.5)",
            color: "#00d4ff",
            "&:hover": {
              borderColor: "#00d4ff",
              bgcolor: "rgba(0,212,255,0.1)",
            },
          }}
        >
          {t('common.export')}
        </Button>
      </Box>
    </Paper>
  );
};

export default OrderFilters;